<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import Qs from 'qs'
import axios from '@/utils/request'

let frequency = { '1': '1分钟内', '2': '1小时内', '3': '24小时内', '4': '1周以内(0-7天)', '5': '1月以内(0-30天)', '6': '1月以上(30天到365天)' }
let platform = { 'MT5': 'MT5', 'GTS2': 'GTS2' }

function getToday() {
  return formatDate(new Date())
}

function getTomorrow() {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return formatDate(tomorrow)
}

function formatDate(date) {
  let year = date.getFullYear()
  let month = (date.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的，所以要加1并确保是两位数
  let day = date.getDate().toString().padStart(2, '0')
  let time = year + '/' + month + '/' + day
  console.info(time)
  return time
}

function getTimestr() {
  return [getToday(), getTomorrow()]
}

export default {
  name: 'frequencyList',
  components: {
    FORM,
    tablePage
  },

  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          {
            title: '时间',
            field: 'time',
            type: 6,
            data: getTimestr(),
            format: 'yyyy/MM/dd',
            startEndParam: ['startTime', 'endTime']
          },
          { title: '交易时长', field: 'frequency', type: 2, optionList: frequency },
          { title: '平台', field: 'platform', type: 2, optionList: platform },
          { click: window.$t('common.search') },
          { click: window.$t('common.export') },
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.sleeping.frequencyList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { field: 'customerNumber', title: '会员账号' },
          { field: 'name', sWidth: '200px', title: '姓名' },
          { field: 'activeDate', title: '激活时间' },
          { field: 'choiceTotal', title: '平仓总量' },
          { field: 'total', title: '开仓总量' },
          { field: 'percent', title: '百分比(%)' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: '同步',
                click: 'synData',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'analyse:frequency:syn'
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'synData') {
        this.synData(row)
      }
    }, synData: function(row) {
      console.info(row)
      this.dataChange(Url.sleeping.frequencySynCustomers, row, res => {
        this.$message.success(res.message)
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.formatDate(data)
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('导出' == clickName || window.$t('common.export') == clickName) {
        this.formatDate(data)
        download.exportExcel(Url.sleeping.frequencyDown, data, 'A客户交易时间长度分类')
      }
    },

    formatDate(data) {
      data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
      data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
    }
  },
  mounted() {
  }
}
</script>

